<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createBankVisible"
    v-loading="createBankProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Bank Account</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="createBankOperation">Create</el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
          >
            Cancel
          </el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          />
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group" v-if="true">
        <el-checkbox
          v-model="createBankForm.default"
          style="margin-left: 0;"
        >
          Make Primary
        </el-checkbox>
      </div>
      <div class="inline-form-group">
        <el-col :span="11">
          <el-input v-model="createBankForm.name" placeholder="Account Name" maxlength="64">
            <template slot="prefix">Name</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="12">
          <el-input v-model="createBankForm.phoneNumber" placeholder="Phone Number" maxlength="10">
            <template slot="prefix">Phone Number</template>
          </el-input>
        </el-col>
      </div>

      <el-select v-model="createBankForm.type" placeholder="Select type">
        <el-option
          v-for="(item, i) in typeOptions"
          :key="i"
          :label="item.label"
          :value="item.value"
        />
        <template slot="prefix">Type</template>
      </el-select>

      <div class="inline-form-group">
        <el-col :span="11">
          <el-input v-model="createBankForm.accountNumber" type="password" placeholder="Account Number" maxlength="17">
            <template slot="prefix">Account Number</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="12">
          <el-input v-model="createBankForm.routingNumber" type="password" placeholder="Routing Number" maxlength="9">
            <template slot="prefix">Routing Number</template>
          </el-input>
        </el-col>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>

import DadsSelect from "@/components/select";

export default {
  name: "BankAccountCreateForm",

  props: {
    createBankVisible: {required: true},
    clearFormFields: {required: true},
    createBankProcessing: {required: true},
    typeOptions: {required: true}
  },

  components: {
    DadsSelect,
  },

  data() {
    return {
      createBankForm: {
        name: "",
        type: "",
        phoneNumber: "",
        default: false,
        accountNumber: "",
        routingNumber: "",
        paymentType: "bank"
      },
    };
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    }
  },

  methods: {
    createBankOperation() {

      const { valid, error } = this.validateFields();

      if(!valid){
        this.$notify({
          title: 'Invalid data',
          message: error,
          type: 'error'
        })
        return;
      }

      const createBody = {...this.createBankForm};
      this.$emit("createBankOperation", createBody);
    },

    cancelOperation() {
      this.clearFields();
      this.$emit("cancelOperation", "create");
    },

    validateFields() {

      const { name, type, phoneNumber, accountNumber, routingNumber} = this.createBankForm;
      let response = {valid: true, error: null};
      const rules = [
        {
          valid: name.length > 0,
          message: 'Name is required'
        },
       {
          valid: ['PERSONAL_CHECKING', 'PERSONAL_SAVINGS', 'BUSINESS_CHECKING', 'BUSINESS_SAVINGS'].includes(type),
          message: 'Select a valid account type'
        },
        {
          valid: phoneNumber.length === 10,
          message: 'Phone number must be exactly 10 digits'
        },
        {
          valid: accountNumber.length > 3,
          message: 'Account number must be at least 4 digits'
        },
        {
          valid: routingNumber.length === 9,
          message: 'Routing number must be exactly 9 digits'
        }
      ];

      for(let item of rules){
        if(!item.valid){
          response = {
            valid: false,
            error: item.message
          }
          break;
        }
      }

      return response;

    },

    clearFields() {
      this.createBankForm = {
        name: "",
        type: "",
        phoneNumber: "",
        default: false,
        accountNumber: "",
        routingNumber: "",
        paymentType: "bank"
      };
    }
  }
};
</script>
